export enum CropCyclesPeriodSelectorEnum {
  CropWeek = 1,
  Full = 2,
  ToDate = 3
}
